import tryPerformRowAutoMarkAsRead from '../../helpers/tryPerformRowAutoMarkAsRead';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import store from 'owa-mail-store/lib/store/Store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { trace } from 'owa-trace';
import { action, select } from 'satcheljs/lib/legacy';

export interface OnReadingPaneClosedState {
    globalReadingPanePosition: ReadingPanePosition;
    showReadingPane: boolean;
    showListPane: boolean;
    userOptions: UserOptionsType;
}

/**
 * Called after the reading pane is closed in single line view
 * @param conversationRowKey the key of row shown in reading pane before it's closed
 * @param tableView the tableView where the single selection changed
 * @param isUserNavigation whether the navigation is triggerred by the user
 * @param state the state which contains the global reading pane position and showReadingPane and showListPane
 */
export default action('onReadingPaneClosed')(
    select({
        globalReadingPanePosition: () =>
            getUserConfiguration().UserOptions.GlobalReadingPanePositionReact,
        showReadingPane: () => store.mailModule.showReadingPane,
        showListPane: () => store.mailModule.showListPane,
        userOptions: () => getUserConfiguration().UserOptions,
    })(function onReadingPaneClosed(
        rowKey: string,
        tableView: TableView,
        state?: OnReadingPaneClosedState
    ) {
        const { globalReadingPanePosition, showReadingPane, showListPane, userOptions } = state;

        if (
            !(
                globalReadingPanePosition == ReadingPanePosition.Off &&
                !showReadingPane &&
                showListPane
            )
        ) {
            trace.error(
                'onReadingPaneClosed should only be called when reading pane is closed in single line view.'
            );
        }

        if (userOptions.PreviewMarkAsRead == 'OnSelectionChange') {
            tryPerformRowAutoMarkAsRead(rowKey, tableView);
        }
    })
);
